module.exports = __webpack_public_path__ + "static/media/30OIOS1.f3433a48.jpg";